import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '@store'

Vue.use(VueRouter)

const loginMustRoutes = ["Advertiser", "Dashboard", "CreateCampaign", "Account", "AboutUsFinance", "ContactUsAdvertiser", "Finance", "Admin", "AdminDashboard", "AdminCreateCampaign", "AdminDrivers", "AdminCampaigns", "AdminAdvertisers", "Driver", "DriverAccount", "DriverFinance"]

const routes = [
  {
    path: '*',
    name: 'Main',
    component: () => import("@components/Main"),
    children: [
      {
        path: '/after-auth',
        name: 'AfterAuth',
        component: () => import("@components/AfterAuth")
      },
      {
        path: '/signupadvertiser',
        name: 'SignUpAdvertiser',
        component: () => import("@components/SignUpAdvertiser")
      },
      {
        path: '/signupdriver',
        name: 'SignUpDriver',
        component: () => import("@components/SignUpDriver")
      },
      {
        path: '/login',
        name: 'SignIn',
        component: () => import("@components/SignIn")
      },
    ]
  },
  {
    path: '/driver-profile-completion',
    name: 'DriverProfileCompletion',
    component: () => import("@views/footerviews/signup/DriverProfileCompletion")
  },
  {
    path: '/advertiser-profile-completion',
    name: 'AdvertiserProfileCompletion',
    component: () => import("@views/footerviews/signup/AdvertiserProfileCompletion")
  },
  // {
  //   path: '/home',
  //   name: 'Home',
  //   component: Home
  // },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../@views/About.vue')
  // },
  {
    path: '/advertisertc',
    name: 'AdvertiserTermsAndConditions',
    component: () => import("@views/footerviews/termsconditions/AdvertiserTermsAndConditions")
  },
  {
    path: '/drivertc',
    name: 'DriverTermsAndConditions',
    component: () => import("@views/footerviews/termsconditions/DriverTermsAndCoditions")
  },
  {
    path: '/privacypolicy',
    name: 'PrivacyPolicy',
    component: () => import("@views/footerviews/PrivacyPolicy")
  },
  {
    path: '/contactus',
    name: 'ContactUs',
    component: () => import("@views/footerviews/ContactView")
  },
  {
    path: '/advertiser',
    name: 'Advertiser',
    component: () => import("@components/advertiser/Advertiser"),
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import("@components/manager/Dashboard")
      },
      {
        path: 'campaign',
        name: 'CreateCampaign',
        component: () => import("@components/manager/CreateCampaign"),
        children: [
          {
            path: 'edit/:id',
            name: 'EditCampaign',
            component: () => import("@components/manager/CreateCampaign")
          }
        ]
      },
      {
        path: 'account',
        name: 'Account',
        component: () => import("@views/advertiser/Account")
      },
      {
        path: 'aboutus',
        name: 'AboutUsFinance',
        component: () => import("@views/advertiser/Aboutus")
      },
      {
        path: 'contactus',
        name: 'ContactUsAdvertiser',
        component: () => import("@components/manager/AdvertiserContact")
      },
      {
        path: 'finance',
        name: 'Finance',
        component: () => import("@views/advertiser/Finance")
      }
    ]
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import("@views/admin/Admin"),
    children: [
      {
        path: '',
        name: 'AdminDashboard',
        component: () => import("@components/admin/AdminDashboard")
      },
      {
        path: 'dashboard',
        name: 'AdminDashboard',
        component: () => import("@components/admin/AdminDashboard")
      },
      {
        path: 'createcampaign',
        name: 'AdminCreateCampaign',
        component: () => import("@components/manager/CreateCampaign")
      },
      {
        path: 'drivers',
        name: 'AdminDrivers',
        component: () => import("@components/admin/AdminDrivers")
      },
      {
        path: 'devices',
        name: 'AdminDevices',
        component: () => import("@components/admin/AdminDevices/AdminDevices.vue")
      },
      {
        path: 'campaigns',
        name: 'AdminCampaigns',
        component: () => import("@components/admin/AdminCampaigns")
      },
      {
        path: 'advertisers',
        name: 'AdminAdvertisers',
        component: () => import("@components/admin/AdminAdvertisers")
      },
      {
        path: 'reports',
        name: 'AdminReports',
        component: () => import("@components/admin/AdminReports/AdminReports")
      }
    ]
  },
  {
    path: '/driver',
    name: 'Driver',
    component: () => import("@views/driver/Driver"),
    children: [
      {
        path: '',
        name: 'DriverAccount',
        component: () => import("@components/driver/DriverAccount")
      },
      {
        path: 'account',
        name: 'DriverAccount',
        component: () => import("@components/driver/DriverAccount")
      },
      {
        path: 'finance',
        name: 'DriverFinance',
        component: () => import("@components/driver/DriverFinance")
      }
    ]
  },
  {
    path: '/password-reset',
    name: 'PasswordReset',
    component: () => import("@views/resetpassword/ResetPassword")
  },
  {
    path: '/login',
    redirect: "/",
    // name: 'Login',
    // component: () => import("@views/login/Login")
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () => import("@components/logout/Logout")
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.onReady(() => document.documentElement.classList.add("app-ready"));

router.beforeEach((to, from, next) => {
  document.title = to.name
  let token = store.getters['getToken']
  if (loginMustRoutes.includes(to.name) && (token === "undefined" || token === null)) {
    next('/login')
  } else {
    next()
  }
})

router.afterEach((to) => {
  gtag('config', window.GA_TRACKING_ID, {
    page_path: to.fullPath,
  })
})

export default router
